export enum StorageType {
    Cloud = 1,
    OnPrem = 2
}
